import { useSelector } from "react-redux";
import SearchInput from "../Search/Search";
import {
  LoaderContainer,
  CategoryBarContainer,
  CategoryList,
  Category,
} from "./CategoryBar.styles";
import { categoriesData } from "../../store/slices/gift/slice";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import MiniLoader from "../MiniLoader/MiniLoader";

const CategoryBar = ({ ar }) => {
  const categories = useSelector(categoriesData);
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation();
  const { categoryId } = useParams();

  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    navigate(`/admin-portal/category-items/${categoryId}`);
  };

  return (
    <CategoryBarContainer $ar={ar}>
      {categories.length > 0 ? (
        <>
          <SearchInput
            styles2={{
              marginTop: "2rem",
              marginBottom: "1rem",
              borderRadius: 10,
              background: "#f6f6f9",
              boxShadow: "0px 0px 5px rgba(0,0,0,0.15)",
            }}
            searchStyle2
            placeholder={t("search-categories")}
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <CategoryList className="vertical-scroll">
            {categories
              .filter((category) =>
                category.name.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map((category) => (
                <Category
                  $active={category.id === +categoryId}
                  key={category.id}
                  onClick={() => {
                    handleCategoryClick(category.id);
                  }}
                >
                  {t(
                    "categories." +
                      [
                        category.name
                          .toLowerCase()
                          .replace(" ", "-")
                          .replace("/", "-"),
                      ]
                  )}
                </Category>
              ))}
          </CategoryList>
        </>
      ) : (
        <LoaderContainer>
          <MiniLoader small />
        </LoaderContainer>
      )}
    </CategoryBarContainer>
  );
};

export default CategoryBar;
